import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { isMobile, isTablet } from 'react-device-detect'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import './TermModal.scss'

export default props => {
  const { isOpen, toggle, current } = props
  const { name, url } = current
  const modalTitleId = 'terms-modal-title'
  const pdfViewerParams = isTablet ? 'navpanes=0&pagemode=none' : 'navpanes=1&pagemode=thumbs'
  const pdfUrl = url ? `${url}#${pdfViewerParams}` : ''
  const useIframeEmbed = isMobile || isTablet

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      id="termsModal"
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close terms and conditions" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="text-center">
          {name}
        </h2>
        {url &&
          (useIframeEmbed ? (
            <iframe
              className="terms-modal-pdf w-100"
              src={pdfUrl}
              title={`Terms document: ${name}`}
              aria-label={`PDF document: ${name}`}
            />
          ) : (
            <object
              className="terms-modal-pdf w-100"
              data={pdfUrl}
              type="application/pdf"
              aria-label={`PDF document: ${name}`}
              title={`Terms document: ${name}`}
            >
              <p>
                <FormattedMessage
                  id="global.label.pdfFallback"
                  defaultMessage="Your browser doesn't support embedded PDFs. You can {downloadLink} to view it."
                  values={{
                    downloadLink: (
                      <a
                        href={url}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Download ${name} PDF (opens in a new window)`}
                      >
                        <FormattedMessage defaultMessage="Download the document" />
                      </a>
                    ),
                  }}
                />
              </p>
            </object>
          ))}
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <a
                href={url}
                download
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Download ${name} (opens in a new window)`}
                className="d-block w-100"
              >
                <Button block outline color="danger">
                  <FormattedMessage id="global.label.download" />
                </Button>
              </a>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}
